import React, { Component } from 'react';

import AuthService from '../state/auth.service';
import AuthUtils from '../AuthUtils';
import UserApi from '../api/user';

import { Redirect } from 'react-router-dom';

let getUrl = async user => {
    if (!user) {
        return '/account/signin';
    }

    let resource = AuthUtils.getAccesses(user.resource);

    let orgs = resource.organizations ? Object.keys(resource.organizations) : [];
    let pracs = resource.practices ? Object.keys(resource.practices) : [];
    if (resource.consultant) {
        return '/consultant/dashboard';
    } else if (orgs.length > 0) {
        for (let i = 0; i < orgs.length; i++) {
            let org = orgs[i];

            /*
             * Get the template used for the organization.
             * Currently, non-consultants are only apart of one
             * Initial, and/or one Annual organization.
             * Here we just want to check if it is not
             * and Annual organization.
             */
            let tool = await UserApi.getOrgTool(org);
            // If it is not an Annual organization.
            if (!tool.includes('ANNUAL')) {
                return `/organization/${org}`;
            }
        }
    } else if (pracs.length > 0) {
        for (let i = 0; i < pracs.length; i++) {
            let prac = pracs[i];
            let tool = await UserApi.getPracticeTool(prac);
            // If it is not an Annual organization.
            if (!tool.includes('ANNUAL')) {
                return `/practice/${prac}`;
            }
        }
    }
};

class HomePage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: '',
        };
    }
    async componentDidMount() {
        let url = await getUrl(AuthService.getUser());
        this.setState({ redirect: url });
    }

    renderRedirect = () => {
        if (this.state.redirect !== '') {
            return <Redirect to={this.state.redirect} />;
        }
    };

    render() {
        return <div className="LoginPage">{this.renderRedirect()}</div>;
    }
}

export default HomePage;
